import { render, staticRenderFns } from "./MHCoachingStart.vue?vue&type=template&id=a6da926c"
import script from "./MHCoachingStart.vue?vue&type=script&lang=js"
export * from "./MHCoachingStart.vue?vue&type=script&lang=js"
import style0 from "./MHCoachingStart.vue?vue&type=style&index=0&id=a6da926c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports